import { axios } from "lib/axios";

export const createAccountWithEmailAndPassword = data => {
  return axios.post("/auth/register", data);
};
